import { BrowserModule } from '@angular/platform-browser';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxImageCompressService } from 'ngx-image-compress';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from './angular-material/angular-material.module';
import { PageNotFoundComponent } from './shared-components/page-not-found/page-not-found.component';
import { HttpClientModule } from '@angular/common/http';
import { LoaderComponent } from './shared-components/loader/loader.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';

@NgModule({
    declarations: [
        AppComponent,
        PageNotFoundComponent,
        LoaderComponent
        // WarningDialogComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        AngularMaterialModule,
        HttpClientModule,
        MatExpansionModule,
        BackButtonDisableModule.forRoot({
            preserveScrollPosition: true
        })
    ],
    providers: [NgxImageCompressService],
    schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent]
})
export class AppModule { }
